
import { computed } from 'vue'

import { toRefs, reactive, watch, toRaw } from "vue"
import axios from "axios"
import { auth, app, firestore } from "./firebase"

import { doc, setDoc, addDoc, getDoc, collection, query, where, getDocs, onSnapshot, deleteDoc, or, and } from "firebase/firestore"
import config from "../../config"
import authenticationService from "./authenticationService"


import fileServiceModule from "./fileService"



let options = {}

const collectionName = 'settings'

const unsubscribeHandles = []

const state = reactive({
    initialized: false,
    initializing: false,
    error: null,
    settings: [],
})


async function teardown() {
    for (let unsubscribeHandle of unsubscribeHandles) {
        await unsubscribeHandle()
    }
    unsubscribeHandles.length = 0
    state.settings = []
}


async function load() {

    await teardown()

    let companyId = authenticationService.companyId && authenticationService.companyId.value ? authenticationService.companyId.value : null
    if (!companyId) {
        console.error('no companyId', companyId)
        return
    }

    const q = query(collection(firestore, collectionName),
        where("companyId", "==", companyId),
    )

    const unsubscribeHandle = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
            const { newIndex, oldIndex, doc, type } = change
            let data = doc.data()
            data.id = doc.id

            if (type === "added") {
                state.settings.splice(newIndex, 0, data)
            }

            if (type === "modified") {
                state.settings.splice(oldIndex, 1)
                state.settings.splice(newIndex, 0, data)
            }

            if (type === "removed") {
                state.settings.splice(oldIndex, 1)
            }

        })
    })
    unsubscribeHandles.push(unsubscribeHandle)
}

async function save(document) {

    let companyId = authenticationService.companyId && authenticationService.companyId.value ? authenticationService.companyId.value : null
    if (!companyId) {
        console.error('no companyId', companyId, authenticationService)
        return
    }

    document.companyId = companyId



    let fileService = null

    for (let key in document) {
        let value = document[key]
        value = document[key] = toRaw(value)
        console.log('value', value)
        //only upload picuture if ist really a blob
        if (value && value instanceof Blob) {
            if (!fileService) {
                fileService = fileServiceModule()
            }
            let uploadResult = await fileService.uploadFile(value)            
            if(uploadResult && uploadResult.name){
                document[key] = uploadResult.name
            }
        }
    }

    let data = structuredClone(toRaw(document))
    // let data = JSON.parse(JSON.stringify(document))
    delete data.id



    if (!document.id) {
        document.id = document.companyId + '-' + document.name
    }


    try {

        if (options && options.restUrl) {
            let token = await auth.currentUser.getIdToken()

            console.log('sending data via URL ', data)
            //make sure the url has all / needed
            let url = '' + config.url
            if (!url.endsWith('/')) {
                url = url + '/'
            }
            if (url.endsWith('/') && options.restUrl.startsWith('/')) {
                url = url.slice(0, -1) //remove the last char : /
            }

            url = url + options.restUrl
            if (!url.endsWith('/')) {
                url = url + '/'
            }

            let response = await axios.post(url + (document.id ? document.id : ''), data, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            })
            if (!response || !response.data) {
                throw new Error("incomplete return value")
            }
            console.log('response', response)
            return response.data && response.data.id ? response.data.id : null

        } else {
            const entryRef = document.id ? doc(firestore, collectionName, document.id) : doc(collection(firestore, collectionName))
            console.log('entryRef', entryRef)
            await setDoc(entryRef, data, { merge: true })
        }


    } catch (error) {
        throw error
    }
}


function getDocumentById(id) {
    if (!state.settings) {
        return null
    }
    for (let setting of state.settings) {
        if (setting.id == id) {
            return setting
        }
    }
    return null
}


if (!state.initialized && !state.initializing) {
    state.initializing = true

    watch(authenticationService.companyId, async (companyId) => {
        if (companyId) {
            load()
        } else {
            teardown()
        }
    })

    if (authenticationService.companyId && authenticationService.companyId.value) {
        load()
    }
    state.initialized = true
    state.initializing = false
}


const getSettingByName = (name) => {
    for (let doc of state.settings) {
        if (doc.name === name) {
            return doc
        }
    }

    //doesnt exist yet -> return a new and empty setting
    let companyId = authenticationService.companyId && authenticationService.companyId.value ? authenticationService.companyId.value : null

    return {
        id: companyId + '-' + name,
        name: name,
        value: null,
        companyId: companyId
    }
}


export default {
    ...toRefs(state),
    teardown,
    save,
    getDocumentById,
    getSettingByName
}


